export const content = {
  TAG_HINZUFUEGEN: 'Tag hinzufügen',
  ABLAUF_GEAENDERT: 'Ablauf geändert',
  HEADING: 'Zeitlicher Ablauf',
  MINDESTENS_EIN_TAG: 'Es muss mindestens ein Ablauftag vorhanden sein.',
  BLOCKUNGEN_VORHANDEN_TOOLTIP: `Diese Veranstaltung hat bereits Ressourcen-Blockungen, weshalb hier nur noch die Uhrzeiten geändert werden können.
  Verwende den Ressourcen-Kalender, um den Ablauf zu ändern.`,
  errorMessages: {
    updateFailed: (msg: string) => `Ablauf konnte nicht geändert werden: ${msg}`,
    updateNotAllowed: 'Nur in Viva erstellte Veranstaltungen, die noch nicht freigegeben sind, dürfen geändert werden',
  },
} as const;
